import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ApiSleepService } from './api-call-providers/api-sleep.service';

@Injectable()
export class SleepService {

  // 睡眠登録
  private registSource = new Subject<any>();
  regist$ = this.registSource.asObservable();

  // 睡眠更新
  private updateSource = new Subject<any>();
  update$ = this.updateSource.asObservable();
 
  // 日別の睡眠状況取得
  private stateListSource = new Subject<any>();
  stateList$ = this.stateListSource.asObservable();

  // 月別の睡眠状況取得
  private stateDetailSource = new Subject<any>();
  stateDetail$ = this.stateDetailSource.asObservable();

  constructor(
    private apiSleepService: ApiSleepService
  ) {
  }

  get loading() {
    return this.apiSleepService.isLoading
  }

  /**
   * 睡眠時間登録
   * @param params
   */
  async regist(params) {
    const result = await this.apiSleepService.post(params)
    // データを再読込
    this.registSource.next(result)
  }

  /**
   * 睡眠時間更新
   * @param params
   */
  async update(params) {
    const result = await this.apiSleepService.put(params)
    // データを再読込
    this.updateSource.next(result)
  }

  async getStateList(targetDate = null) {
    const result = await this.apiSleepService.getStateList(targetDate)
    // データを再読込
    this.stateListSource.next(result)
  }

  async getStateDetail(params) {
    const result = await this.apiSleepService.getStateDetail(params)
    // データを再読込
    this.stateDetailSource.next(result)
  }
}



// WEBPACK FOOTER //
// ./src/providers/sleep.service.ts